// tslint:disable
/**
 * Course API
 * Used for: - Manage courses - Manage course info - Manage students - Learning control 
 *
 * The version of the OpenAPI document: 2.6.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { LearningDate } from '../models';
import { Registration } from '../models';
import { RegistrationCreate } from '../models';
import { RegistrationEdit } from '../models';
import { RegistrationList } from '../models';
import { StudentList } from '../models';
/**
 * CourseRegistrationApi - axios parameter creator
 * @export
 */
export const CourseRegistrationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {LearningDate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeLearningDate(id: string, body: LearningDate, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling changeLearningDate.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling changeLearningDate.');
            }
            const localVarPath = `/course-registration/{id}/change-learning-date`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegistrationCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCourseRegistration(body: RegistrationCreate, options: any = {}): RequestArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createCourseRegistration.');
            }
            const localVarPath = `/course-registrations`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<RegistrationCreate>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCourseRegistrationMany(body: Array<RegistrationCreate>, options: any = {}): RequestArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createCourseRegistrationMany.');
            }
            const localVarPath = `/course-registrations/many`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {RegistrationEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCourseRegistration(id: string, body: RegistrationEdit, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editCourseRegistration.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editCourseRegistration.');
            }
            const localVarPath = `/course-registration/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCourseRegistration(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCourseRegistration.');
            }
            const localVarPath = `/course-registration/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {string} [companyId] 
         * @param {Array<string>} [courseIds] 
         * @param {boolean} [courseEnabled] 
         * @param {Array<string>} [studentIds] 
         * @param {Array<string>} [studentUserIds] 
         * @param {string} [studentName] 
         * @param {Array<'learning' | 'pause' | 'success' | 'fail' | 'abort'>} [statuses] 
         * @param {Date} [startedAtMin] 
         * @param {Date} [startedAtMax] 
         * @param {Date} [finishedAtMin] 
         * @param {Date} [finishedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'startedAt' | 'finishedAt' | 'createdAt' | 'studentName'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCourseRegistrations(ids?: Array<string>, companyId?: string, courseIds?: Array<string>, courseEnabled?: boolean, studentIds?: Array<string>, studentUserIds?: Array<string>, studentName?: string, statuses?: Array<'learning' | 'pause' | 'success' | 'fail' | 'abort'>, startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, offset?: number, limit?: number, sort?: 'startedAt' | 'finishedAt' | 'createdAt' | 'studentName', order?: 'ASC' | 'DESC', options: any = {}): RequestArgs {
            const localVarPath = `/course-registrations`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (courseIds) {
                localVarQueryParameter['courseIds'] = courseIds.join(COLLECTION_FORMATS.csv);
            }

            if (courseEnabled !== undefined) {
                localVarQueryParameter['courseEnabled'] = courseEnabled;
            }

            if (studentIds) {
                localVarQueryParameter['studentIds'] = studentIds.join(COLLECTION_FORMATS.csv);
            }

            if (studentUserIds) {
                localVarQueryParameter['studentUserIds'] = studentUserIds.join(COLLECTION_FORMATS.csv);
            }

            if (studentName !== undefined) {
                localVarQueryParameter['studentName'] = studentName;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses.join(COLLECTION_FORMATS.csv);
            }

            if (startedAtMin !== undefined) {
                localVarQueryParameter['startedAtMin'] = (startedAtMin as any).toISOString();
            }

            if (startedAtMax !== undefined) {
                localVarQueryParameter['startedAtMax'] = (startedAtMax as any).toISOString();
            }

            if (finishedAtMin !== undefined) {
                localVarQueryParameter['finishedAtMin'] = (finishedAtMin as any).toISOString();
            }

            if (finishedAtMax !== undefined) {
                localVarQueryParameter['finishedAtMax'] = (finishedAtMax as any).toISOString();
            }

            if (createdAtMin !== undefined) {
                localVarQueryParameter['createdAtMin'] = (createdAtMin as any).toISOString();
            }

            if (createdAtMax !== undefined) {
                localVarQueryParameter['createdAtMax'] = (createdAtMax as any).toISOString();
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {Array<string>} [studentIds] 
         * @param {string} [name] 
         * @param {string} [email] 
         * @param {string} [belongToContractorId] 
         * @param {string} [notBelongToContractorId] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'name' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCourseRegistrationsAvailableStudents(courseId: string, studentIds?: Array<string>, name?: string, email?: string, belongToContractorId?: string, notBelongToContractorId?: string, createdAtMin?: Date, createdAtMax?: Date, offset?: number, limit?: number, sort?: 'name' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options: any = {}): RequestArgs {
            // verify required parameter 'courseId' is not null or undefined
            if (courseId === null || courseId === undefined) {
                throw new RequiredError('courseId','Required parameter courseId was null or undefined when calling listCourseRegistrationsAvailableStudents.');
            }
            const localVarPath = `/course-registrations/available-students`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (courseId !== undefined) {
                localVarQueryParameter['courseId'] = courseId;
            }

            if (studentIds) {
                localVarQueryParameter['studentIds'] = studentIds.join(COLLECTION_FORMATS.csv);
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (belongToContractorId !== undefined) {
                localVarQueryParameter['belongToContractorId'] = belongToContractorId;
            }

            if (notBelongToContractorId !== undefined) {
                localVarQueryParameter['notBelongToContractorId'] = notBelongToContractorId;
            }

            if (createdAtMin !== undefined) {
                localVarQueryParameter['createdAtMin'] = (createdAtMin as any).toISOString();
            }

            if (createdAtMax !== undefined) {
                localVarQueryParameter['createdAtMax'] = (createdAtMax as any).toISOString();
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CourseRegistrationApi - functional programming interface
 * @export
 */
export const CourseRegistrationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {LearningDate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeLearningDate(id: string, body: LearningDate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Registration> {
            const localVarAxiosArgs = CourseRegistrationApiAxiosParamCreator(configuration).changeLearningDate(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {RegistrationCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCourseRegistration(body: RegistrationCreate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Registration> {
            const localVarAxiosArgs = CourseRegistrationApiAxiosParamCreator(configuration).createCourseRegistration(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<RegistrationCreate>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCourseRegistrationMany(body: Array<RegistrationCreate>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Registration>> {
            const localVarAxiosArgs = CourseRegistrationApiAxiosParamCreator(configuration).createCourseRegistrationMany(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {RegistrationEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCourseRegistration(id: string, body: RegistrationEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Registration> {
            const localVarAxiosArgs = CourseRegistrationApiAxiosParamCreator(configuration).editCourseRegistration(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCourseRegistration(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Registration> {
            const localVarAxiosArgs = CourseRegistrationApiAxiosParamCreator(configuration).getCourseRegistration(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {string} [companyId] 
         * @param {Array<string>} [courseIds] 
         * @param {boolean} [courseEnabled] 
         * @param {Array<string>} [studentIds] 
         * @param {Array<string>} [studentUserIds] 
         * @param {string} [studentName] 
         * @param {Array<'learning' | 'pause' | 'success' | 'fail' | 'abort'>} [statuses] 
         * @param {Date} [startedAtMin] 
         * @param {Date} [startedAtMax] 
         * @param {Date} [finishedAtMin] 
         * @param {Date} [finishedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'startedAt' | 'finishedAt' | 'createdAt' | 'studentName'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCourseRegistrations(ids?: Array<string>, companyId?: string, courseIds?: Array<string>, courseEnabled?: boolean, studentIds?: Array<string>, studentUserIds?: Array<string>, studentName?: string, statuses?: Array<'learning' | 'pause' | 'success' | 'fail' | 'abort'>, startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, offset?: number, limit?: number, sort?: 'startedAt' | 'finishedAt' | 'createdAt' | 'studentName', order?: 'ASC' | 'DESC', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegistrationList> {
            const localVarAxiosArgs = CourseRegistrationApiAxiosParamCreator(configuration).listCourseRegistrations(ids, companyId, courseIds, courseEnabled, studentIds, studentUserIds, studentName, statuses, startedAtMin, startedAtMax, finishedAtMin, finishedAtMax, createdAtMin, createdAtMax, offset, limit, sort, order, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {Array<string>} [studentIds] 
         * @param {string} [name] 
         * @param {string} [email] 
         * @param {string} [belongToContractorId] 
         * @param {string} [notBelongToContractorId] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'name' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCourseRegistrationsAvailableStudents(courseId: string, studentIds?: Array<string>, name?: string, email?: string, belongToContractorId?: string, notBelongToContractorId?: string, createdAtMin?: Date, createdAtMax?: Date, offset?: number, limit?: number, sort?: 'name' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<StudentList> {
            const localVarAxiosArgs = CourseRegistrationApiAxiosParamCreator(configuration).listCourseRegistrationsAvailableStudents(courseId, studentIds, name, email, belongToContractorId, notBelongToContractorId, createdAtMin, createdAtMax, offset, limit, sort, order, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CourseRegistrationApi - factory interface
 * @export
 */
export const CourseRegistrationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {LearningDate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeLearningDate(id: string, body: LearningDate, options?: any) {
            return CourseRegistrationApiFp(configuration).changeLearningDate(id, body, options)(axios, basePath);
        },
        /**
         * 
         * @param {RegistrationCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCourseRegistration(body: RegistrationCreate, options?: any) {
            return CourseRegistrationApiFp(configuration).createCourseRegistration(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<RegistrationCreate>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCourseRegistrationMany(body: Array<RegistrationCreate>, options?: any) {
            return CourseRegistrationApiFp(configuration).createCourseRegistrationMany(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {RegistrationEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCourseRegistration(id: string, body: RegistrationEdit, options?: any) {
            return CourseRegistrationApiFp(configuration).editCourseRegistration(id, body, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCourseRegistration(id: string, options?: any) {
            return CourseRegistrationApiFp(configuration).getCourseRegistration(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {string} [companyId] 
         * @param {Array<string>} [courseIds] 
         * @param {boolean} [courseEnabled] 
         * @param {Array<string>} [studentIds] 
         * @param {Array<string>} [studentUserIds] 
         * @param {string} [studentName] 
         * @param {Array<'learning' | 'pause' | 'success' | 'fail' | 'abort'>} [statuses] 
         * @param {Date} [startedAtMin] 
         * @param {Date} [startedAtMax] 
         * @param {Date} [finishedAtMin] 
         * @param {Date} [finishedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'startedAt' | 'finishedAt' | 'createdAt' | 'studentName'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCourseRegistrations(ids?: Array<string>, companyId?: string, courseIds?: Array<string>, courseEnabled?: boolean, studentIds?: Array<string>, studentUserIds?: Array<string>, studentName?: string, statuses?: Array<'learning' | 'pause' | 'success' | 'fail' | 'abort'>, startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, offset?: number, limit?: number, sort?: 'startedAt' | 'finishedAt' | 'createdAt' | 'studentName', order?: 'ASC' | 'DESC', options?: any) {
            return CourseRegistrationApiFp(configuration).listCourseRegistrations(ids, companyId, courseIds, courseEnabled, studentIds, studentUserIds, studentName, statuses, startedAtMin, startedAtMax, finishedAtMin, finishedAtMax, createdAtMin, createdAtMax, offset, limit, sort, order, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {Array<string>} [studentIds] 
         * @param {string} [name] 
         * @param {string} [email] 
         * @param {string} [belongToContractorId] 
         * @param {string} [notBelongToContractorId] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'name' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCourseRegistrationsAvailableStudents(courseId: string, studentIds?: Array<string>, name?: string, email?: string, belongToContractorId?: string, notBelongToContractorId?: string, createdAtMin?: Date, createdAtMax?: Date, offset?: number, limit?: number, sort?: 'name' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any) {
            return CourseRegistrationApiFp(configuration).listCourseRegistrationsAvailableStudents(courseId, studentIds, name, email, belongToContractorId, notBelongToContractorId, createdAtMin, createdAtMax, offset, limit, sort, order, options)(axios, basePath);
        },
    };
};

/**
 * CourseRegistrationApi - object-oriented interface
 * @export
 * @class CourseRegistrationApi
 * @extends {BaseAPI}
 */
export class CourseRegistrationApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {LearningDate} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseRegistrationApi
     */
    public changeLearningDate(id: string, body: LearningDate, options?: any) {
        return CourseRegistrationApiFp(this.configuration).changeLearningDate(id, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {RegistrationCreate} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseRegistrationApi
     */
    public createCourseRegistration(body: RegistrationCreate, options?: any) {
        return CourseRegistrationApiFp(this.configuration).createCourseRegistration(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<RegistrationCreate>} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseRegistrationApi
     */
    public createCourseRegistrationMany(body: Array<RegistrationCreate>, options?: any) {
        return CourseRegistrationApiFp(this.configuration).createCourseRegistrationMany(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {RegistrationEdit} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseRegistrationApi
     */
    public editCourseRegistration(id: string, body: RegistrationEdit, options?: any) {
        return CourseRegistrationApiFp(this.configuration).editCourseRegistration(id, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseRegistrationApi
     */
    public getCourseRegistration(id: string, options?: any) {
        return CourseRegistrationApiFp(this.configuration).getCourseRegistration(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {string} [companyId] 
     * @param {Array<string>} [courseIds] 
     * @param {boolean} [courseEnabled] 
     * @param {Array<string>} [studentIds] 
     * @param {Array<string>} [studentUserIds] 
     * @param {string} [studentName] 
     * @param {Array<'learning' | 'pause' | 'success' | 'fail' | 'abort'>} [statuses] 
     * @param {Date} [startedAtMin] 
     * @param {Date} [startedAtMax] 
     * @param {Date} [finishedAtMin] 
     * @param {Date} [finishedAtMax] 
     * @param {Date} [createdAtMin] 
     * @param {Date} [createdAtMax] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {'startedAt' | 'finishedAt' | 'createdAt' | 'studentName'} [sort] 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseRegistrationApi
     */
    public listCourseRegistrations(ids?: Array<string>, companyId?: string, courseIds?: Array<string>, courseEnabled?: boolean, studentIds?: Array<string>, studentUserIds?: Array<string>, studentName?: string, statuses?: Array<'learning' | 'pause' | 'success' | 'fail' | 'abort'>, startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, offset?: number, limit?: number, sort?: 'startedAt' | 'finishedAt' | 'createdAt' | 'studentName', order?: 'ASC' | 'DESC', options?: any) {
        return CourseRegistrationApiFp(this.configuration).listCourseRegistrations(ids, companyId, courseIds, courseEnabled, studentIds, studentUserIds, studentName, statuses, startedAtMin, startedAtMax, finishedAtMin, finishedAtMax, createdAtMin, createdAtMax, offset, limit, sort, order, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} courseId 
     * @param {Array<string>} [studentIds] 
     * @param {string} [name] 
     * @param {string} [email] 
     * @param {string} [belongToContractorId] 
     * @param {string} [notBelongToContractorId] 
     * @param {Date} [createdAtMin] 
     * @param {Date} [createdAtMax] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {'name' | 'createdAt' | 'updatedAt'} [sort] 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseRegistrationApi
     */
    public listCourseRegistrationsAvailableStudents(courseId: string, studentIds?: Array<string>, name?: string, email?: string, belongToContractorId?: string, notBelongToContractorId?: string, createdAtMin?: Date, createdAtMax?: Date, offset?: number, limit?: number, sort?: 'name' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any) {
        return CourseRegistrationApiFp(this.configuration).listCourseRegistrationsAvailableStudents(courseId, studentIds, name, email, belongToContractorId, notBelongToContractorId, createdAtMin, createdAtMax, offset, limit, sort, order, options)(this.axios, this.basePath);
    }

}
